import React, { useEffect, useState,useRef } from "react";
import { connect } from "react-redux";
import {Link} from 'react-router-dom';
import _ from "lodash";
import Modal from "react-bootstrap/Modal";
import Logo from "../../assets/normLogo.png";
import Form from "react-bootstrap/Form";
import CloseButton from "react-bootstrap/esm/CloseButton";
import FloatingLabel from "react-bootstrap/FloatingLabel";
import Swal from "sweetalert2";
import Pagination from "react-js-pagination";
import Loader from '../../elements/Loader';
import {cityUpdate,hidecityModal,showcityModal,showEditcityModal,hideEditcityModal,getcitys,cityEdit,inputHandler,registercity, cityDelete} from "../../../redux/actions";

function Cities(props) {


// const [addcityData,setAddcityData] = useState({name:''});
const [cityData,setcityData] = useState({name:'',onId:''});
const [checkedState, setCheckedState] = useState([]);
const checkBoxRef = useRef([]);


  useEffect(() => {
    props.getcitys(props.currentPage);

  }, [props.registercitySuccess,props.updateSuccess,props.deleteSuccess]);


useEffect(()=>{
setcityData({...cityData,'name':props.editDetails?.data?.city_name||''})
},[props.editDetails])



  //   useEffect(()=>{

  //     setRoleNameEdit({name:props.showPermissions?.role.name?props.showPermissions?.role.name:''});
    
     
  
  
  // },[props.showPermissions] )



  const onInputchange = (e) => {
    props.inputHandler({ key: e.target.name, value: e.target.value });
    // setRoleData({ ...roleData, [e.target.name]: e.target.value });
  };





  const onInputUpdatechange = (e) => {
    // props.inputHandler({ key: e.target.name, value: e.target.value });
    setcityData({...cityData, name:e.target.value  });
  };

// ============================================
//  to rigister role modal
// ============================================
  const handleClose = () => {
  
    props.hidecityModal()

  };
  const handleShow = () => {

    props.showcityModal()
  
  };

// ============================================
// to register edit modal open and close
// ============================================

  const handleEditClose = () => {
    props.hideEditcityModal();

  };

  const handleEditShow=()=>{
    props.showEditcityModal()

  }




const deletecity = (id) => {
  Swal.fire({
    title: "Are you sure?",
    text: "You want to delete this city",
    icon: "warning",
    width: 400,
    showCancelButton: true,
    timer: 4000,
    timerProgressBar: true,
    confirmButtonColor: "#3085d6",
    cancelButtonColor: "#d33",
    confirmButtonText: "Yes, delete it!",
  }).then((result) => {
    if (result.isConfirmed) {
      props.cityDelete(id, props.currentPage);
    }
  });
};





const submitcity = (e) => {
  e.preventDefault();
  let name=props?.name;
  if(name){
    props.registercity(name)
  }
}


const Updatecity = (e) => {
  e.preventDefault();
  let name=cityData.name;
  let id=cityData.onId;
  let currentPage=props.citysList?.data?.current_page;
  props.cityUpdate(id,name,currentPage);
  
}




  return (
    <>
      

      <div className="container-Layer">
      <Link to="/home/settings" className="back-button-outer">

    <center> <i className="fa fa-arrow-left" style={{color:'white'}}></i> </center> 
      </Link>

      <div className="row">
      <div className="col-md-7"> 
        
     <div className="addButton"><a onClick={handleShow} className="btn btn-primary">Add City</a></div> 
      </div>
      <div className="col-md-5">

      </div>

     
        </div>

        <div className="row text-center pt-4">
          {props.loading ? 
            <Loader
              width={"40px"}
              height={"40px"}
              iconColor={"white"}
              backgroundColor={"#deb726"}
              left={"0%"}
              top={"30%"}
            />
          :
            props.citysList?.data?.data.map((list, index) => {
              return (
                <div
                  className="col-xl-3 col-sm-4 col-md-4 mb-5 card-outer"
                  key={index}
                >
                
            <div
              className="shadow-sm py-2 px-4 settings-list-card "
              style={{ borderLeft: "5px solid #fcba03" }}
            >
              <p className="mt-2 text-uppercase">{list.city_name}</p>
              {/* <span className="small text-uppercase text-muted">Admin</span> */}
              <ul className="social mb-0 list-inline mt-3">
                
                <li className="list-inline-item settings-links">
                  <a  onClick={
                    ()=>{
                      props.cityEdit(list.id)
                      setcityData({...cityData,'onId':list.id})
                      setTimeout(()=>{
                        handleEditShow()

                      },190)
                          

                    }} className="icons-link">
                    <i className="fa fa-edit edit"></i>
                  </a>
                </li>
                <li className="list-inline-item settings-links">
                  <a  onClick={()=>deletecity(list.id)} className="icons-link">
                    <i className="fa fa-trash trash"></i>
                  </a>
                </li>
              </ul>
            </div>
          </div>
              );
            })}

          
            {props.citysList && (
        <div className="row">
          <div className="paginate col-md-6">
            <Pagination
              activePage={props.citysList?.data?.current_page}
              itemsCountPerPage={props.citysList?.data?.per_page}
              totalItemsCount={props.citysList?.data.total}
              //   pageRangeDisplayed={5}
              onChange={(pageNumber) => props.getcitys(pageNumber)}
              itemClass="page-item"
              linkClass="page-link"
              lastPageText="Last"
              firstPageText="First"
            />
          </div>
        </div>
      )}



        </div>
      </div>


{/* ======================
Add Role Modal
====================== */}
      <Modal show={props.showWarModal} onHide={handleClose} size="md" >
        <Modal.Header className="modal-header-color">
          <img
            src={Logo}
            style={{ width: "70px", height: "35px", paddingRight: "10px" }}
          />
          <Modal.Title className="modal-header-text">Add New city </Modal.Title>
          <CloseButton variant={"white"} onClick={handleClose}></CloseButton>
        </Modal.Header> 

        <form onSubmit={submitcity}>
          <Modal.Body >
            <div className="row">
              <div className="col-md-12 mb-3">
                <FloatingLabel label="city Name">
                  <Form.Control
                    type="input"
                    placeholder=" "
                    name="name"
                    value={props?.name}
                    required
                    onChange={(e) => onInputchange(e)}
                    isInvalid={props.cityRegisterErrors?.error?.city_name?true:false}
                  />

                </FloatingLabel>

                {props.cityRegisterErrors?.error?.city_name ? (
                  <div className="validation-error">
                    The city name already exists !
                  </div>
                ) : (
                  ""
                )}

              </div>
            </div>
   
            {/* <Button text={"Submit"} class={"btn btn-primary"} type={'submit'} /> */}
          </Modal.Body>

          <Modal.Footer className="modal-footer">
            <button className="btn-submit" type="submit">
              Add
            </button>
          </Modal.Footer>
        </form>
      </Modal>











{/* ======================
Edit Role Modal
====================== */}
<Modal show={props.showEditWarModal} onHide={handleEditClose} size="md">
        <Modal.Header className="modal-header-color">
          <img
            src={Logo}
            style={{ width: "70px", height: "35px", paddingRight: "10px" }}
          />
          <Modal.Title className="modal-header-text">Edit city </Modal.Title>
          <CloseButton variant={"white"} onClick={handleEditClose}></CloseButton>
        </Modal.Header> 

        <form onSubmit={Updatecity}>
          <Modal.Body >
            <div className="row">
              <div className="col-md-12 mb-3">
                <FloatingLabel label="city Name">
                  <Form.Control
                    type="input"
                    placeholder=" "
                    name="editcityName"
                    value={cityData.name||''}
                    required
                    onChange={(e) => onInputUpdatechange(e)}
                    isInvalid={props.cityUpdateErrors?.error?.city_name ?true:false}
                  />

                </FloatingLabel>

                {props.cityUpdateErrors?.error?.city_name ? (
                  <div className="validation-error">
                    The city name already exists, you can't update it with this city name !
                  </div>
                ) : (
                  ""
                )}

              </div>
            </div>
    
            {/* <Button text={"Submit"} class={"btn btn-primary"} type={'submit'} /> */}
          </Modal.Body>

          <Modal.Footer className="modal-footer">
            <button className="btn-submit" type="submit">
              Done
            </button>
          </Modal.Footer>
        </form>
      </Modal>








    </>
  );
}

const mapStateToProps = (state) => {
  const {loading,citysList,showWarModal,showEditWarModal,name,registercitySuccess,cityRegisterErrors,currentPage,editDetails,updateSuccess,deleteSuccess,cityUpdateErrors} = state.SettingsCityHandler;

  return {
    loading: loading,
    name:name,
    cityRegisterErrors:cityRegisterErrors,
    currentPage:currentPage,
    citysList:citysList,
    showWarModal:showWarModal,
    showEditWarModal:showEditWarModal,
    registercitySuccess:registercitySuccess,
    editDetails:editDetails,
    updateSuccess:updateSuccess,
    deleteSuccess:deleteSuccess,
    cityUpdateErrors:cityUpdateErrors,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {


    inputHandler: ({ key, value }) => dispatch(inputHandler({ key, value })),
 
      getcitys:(currentPage)=>dispatch(getcitys(currentPage)),
      showcityModal:()=>dispatch(showcityModal()),
      hidecityModal:()=>dispatch(hidecityModal()),
      showEditcityModal:()=>dispatch(showEditcityModal()),
      hideEditcityModal:()=>dispatch(hideEditcityModal()),
      registercity:(name)=>dispatch(registercity(name)),
      cityEdit:(id)=>dispatch(cityEdit(id)),
      cityUpdate:(id,name,currentPage)=>dispatch(cityUpdate(id,name,currentPage)),
      cityDelete:(id,currentPage)=>dispatch(cityDelete(id,currentPage)),
  };


};

export default connect(mapStateToProps, mapDispatchToProps)(Cities);



// =============================
// design version: 1.0
// design by sabaoon bedar
// =============================